export const DATA_IDS = {
    FORBIDDEN_WORDS_LIST_BUTTON_NEW: "forbidden-words-list-button-new",
    FORBIDDEN_WORDS_LIST_FORM_SUBMIT: "forbidden-words-list-form-submit",
    FEATURE_VALIDATIONS_NOT_AVAILABLE: "FEATURE_VALIDATIONS_NOT_AVAILABLE"
};
